module.exports = __webpack_public_path__ + "795ff8437a0ed5603712e5420d5466a7.svg";